import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './services/auth.guard';
import { SecureInnerPagesGuard } from './services/secure-inner-pages.guard';


const routes: Routes = [
  { path: "", redirectTo: '/login', pathMatch: "full" },
  { path: "login", component: LoginComponent, pathMatch: "full", canActivate: [SecureInnerPagesGuard] , data: {title: 'Login'}},
  {
    path: 'home', loadChildren: './home/home.module#HomeModule', canActivate: [AuthGuard],
    data: {
      role: 'USR', title:"home"
    }
  },
  { path: 'admin', loadChildren: './admin/admin.module#AdminModule', canActivate: [AuthGuard],
  data: {
    role: 'ADM', title:"admin"
  }},
  {
    path: "**",
    component: LoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
